import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth';
import { DataContext } from '@services';

export const requiresAuth: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const dataContext = inject(DataContext);
  const router = inject(Router);

  try {
    const isAuthorized = await authService.isAppAuthorized();
    if (!isAuthorized) return router.createUrlTree(['/login']);
    if (!dataContext.loggedInUser()) {
      await authService.loadLoggedInUser();
    }
    return true;
  } catch {
    return router.createUrlTree(['/login']);
  }
};
